"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverBar = void 0;
const react_1 = __importStar(require("react"));
const shared_video_player_hover_section_1 = require("@guidde-co/shared.video-player.hover-section");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const formatTime = (seconds) => {
    const format = (val) => `0${Math.floor(val)}`.slice(-2);
    const hours = seconds / 3600;
    const minutes = (seconds % 3600) / 60;
    const secs = seconds % 60;
    return [...(hours >= 1 ? [hours] : []), minutes, secs].map(format).join(':');
};
const useStyles = (0, makeStyles_1.default)({
    progressBar: {
        position: 'relative',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        zIndex: 12
    },
    hoverBar: {
        height: '100%',
        position: 'absolute',
        backgroundColor: 'rgba(255,255,255,0.4)',
        bottom: 0,
        borderRadius: 0,
        visibility: ({ hoverProgress }) => hoverProgress ? 'visible' : 'hidden',
        width: ({ hoverProgress }) => `${hoverProgress}%`,
        '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            right: '-0.5px',
            height: '100%',
            width: '1px',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
            background: 'black',
            borderRadius: 0
        }
    },
    hoverTime: {
        display: 'block',
        background: 'white',
        color: 'black',
        width: '60px',
        height: '20px',
        position: 'absolute',
        right: '-30px',
        top: '-30px',
        textAlign: 'center',
        borderRadius: '5px',
        zIndex: 26
    }
});
const HoverBar = ({ duration, width, totalPrevWidth, index, totalSections, section, onClick }) => {
    const [hoverProgress, setHoverProgress] = (0, react_1.useState)(0);
    const classes = useStyles({ hoverProgress });
    const progressRef = (0, react_1.useRef)();
    const allWidthsOnHover = totalPrevWidth + (width / 100) * hoverProgress;
    const currentTimeOnHover = (duration / 100) * allWidthsOnHover;
    const onProgressClick = e => {
        const rect = e.target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const fullWidth = progressRef.current.clientWidth;
        const sectionPercentage = (((x / fullWidth) * 100) / 100) * width;
        const totalPercentage = totalPrevWidth + sectionPercentage;
        onClick(totalPercentage || 0);
    };
    return (react_1.default.createElement("div", { ref: progressRef, className: classes.progressBar, onClick: onProgressClick, onMouseLeave: () => setHoverProgress(null), onMouseMove: e => {
            e.preventDefault();
            e.stopPropagation();
            const rect = e.target.getBoundingClientRect();
            if (e.clientX < rect.left || e.clientX >= rect.right)
                return;
            const x = e.clientX - rect.left;
            const fullWidth = progressRef.current.clientWidth;
            const percentage = (x / fullWidth) * 100;
            setHoverProgress(percentage);
        } },
        react_1.default.createElement(Box_1.default, { className: classes.hoverBar },
            react_1.default.createElement(Box_1.default, { className: classes.hoverTime, id: "hover-time" }, formatTime(currentTimeOnHover)),
            react_1.default.createElement(shared_video_player_hover_section_1.HoverSection, { section: section, index: index, totalSections: totalSections }))));
};
exports.HoverBar = HoverBar;
//# sourceMappingURL=hover-bar.js.map